import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgCvKetel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M27.44 25H12.56a.56.56 0 0 0-.56.56v5.88c0 .31.25.56.56.56h14.88c.31 0 .56-.25.56-.56v-5.88a.56.56 0 0 0-.56-.56"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.5 32a2.5 2.5 0 0 1-2.5 2.5h-3v-1h3a1.5 1.5 0 0 0 1.5-1.5zM22.5 32a1.5 1.5 0 0 0 1.5 1.5h3v1h-3a2.5 2.5 0 0 1-2.5-2.5z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M11 27v2.9a1.1 1.1 0 0 0 1.1 1.1h15.8a1.1 1.1 0 0 0 1.1-1.1V27zM29 26V8.1A1.1 1.1 0 0 0 27.9 7H12.1A1.1 1.1 0 0 0 11 8.1V26z"
    />
    <path
      fill="#FFBFA5"
      d="M19.96 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.668 12.054a3.5 3.5 0 0 0-1.927-.396l-.082-.996a4.499 4.499 0 0 1 4.016 7.12l-.81-.585a3.5 3.5 0 0 0-1.197-5.143"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="m18.85 13 1.65 2.93a.48.48 0 0 1-.26.65.54.54 0 0 1-.71-.16.3.3 0 0 1 0-.12z"
    />
    <path
      fill="#FFBFA5"
      d="M19 5h-2v2h2zM23 5h-2v2h2zM23 31h-2v2h2zM19 31h-2v2h2z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgCvKetel);

export default ForwardRef;
